/* DK Offroad theme behaviour: header menus, collection filters, product options/gallery, video, waitlist.
   Add-to-cart and the cart drawer stay with Dawn's product-form.js / cart-drawer.js. */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- money (cents → shop format, trailing .00 dropped) ---------- */
  function money(cents) {
    const fmt = window.DK_MONEY_FORMAT || '${{amount}}';
    const n = (Number(cents) || 0) / 100;
    const two = n.toFixed(2);
    const withCommas = (s, sep = ',', dec = '.') => {
      const [i, d] = s.split('.');
      const out = i.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return d && d !== '00' ? out + dec + d : out;
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      if (key === 'amount_no_decimals') return withCommas(n.toFixed(0));
      if (key === 'amount_with_comma_separator') return withCommas(two, '.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return withCommas(n.toFixed(0), '.');
      return withCommas(two);
    });
  }

  /* ---------- header ---------- */
  function initHeader(root) {
    const trigger = $('[data-dk-mega]', root);
    const panel = $('[data-dk-mega-panel]', root);
    let closeTimer;
    const setMega = (open) => {
      if (!panel) return;
      panel.classList.toggle('open', open);
      trigger.setAttribute('aria-expanded', String(open));
    };
    if (trigger && panel) {
      if (matchMedia('(hover: hover)').matches) {
        [trigger, panel].forEach((el) => {
          el.addEventListener('mouseenter', () => { clearTimeout(closeTimer); setMega(true); });
          el.addEventListener('mouseleave', () => { closeTimer = setTimeout(() => setMega(false), 180); });
        });
      }
      trigger.addEventListener('click', () => setMega(!panel.classList.contains('open')));
      document.addEventListener('click', (e) => { if (!e.target.closest('[data-dk-mega], [data-dk-mega-panel]')) setMega(false); });
    }
    const openMenu = (open) => {
      root.classList.toggle('menu-open', open);
      const m = $('.menu-panel', root);
      if (m) m.setAttribute('aria-hidden', String(!open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
    };
    $$('[data-dk-menu]', root).forEach((b) => b.addEventListener('click', () => openMenu(true)));
    $$('[data-dk-menu-close], [data-dk-scrim]', root).forEach((b) => b.addEventListener('click', () => openMenu(false)));
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      setMega(false);
      openMenu(false);
    });
  }

  /* ---------- collection filters + sort ---------- */
  function initCollection() {
    const form = $('[data-dk-filters]');
    const sort = $('[data-dk-sort]');
    const go = () => {
      const params = new URLSearchParams(form ? new FormData(form) : undefined);
      for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
      if (sort) params.set('sort_by', sort.value);
      params.delete('page');
      const base = form ? form.getAttribute('action') : location.pathname;
      location.href = base + (params.toString() ? '?' + params.toString() : '');
    };
    if (form) {
      form.addEventListener('change', go);
      form.addEventListener('submit', (e) => { e.preventDefault(); go(); });
    }
    if (sort) sort.addEventListener('change', go);
    const t = $('[data-dk-ftoggle]');
    if (t && form) t.addEventListener('click', () => form.classList.toggle('open'));
  }

  /* ---------- product ---------- */
  function initProduct(root) {
    const variants = JSON.parse(($('[data-dk-variants]', root) || {}).textContent || '[]');
    const idInput = $('input[name="id"]', root);
    const addBtn = $('[data-dk-add]', root);
    const addText = addBtn && addBtn.querySelector('span');
    const prices = $$('[data-dk-price]', root);
    const stock = $('[data-dk-stock]', root);
    const groups = $$('[data-dk-option]', root);

    // gallery
    const main = $('[data-dk-main]', root);
    const thumbs = $$('[data-dk-thumb]', root);
    let current = Math.max(0, thumbs.findIndex((t) => t.classList.contains('on')));
    const show = (i) => {
      if (!main || !thumbs.length) return;
      current = (i + thumbs.length) % thumbs.length;
      main.removeAttribute('srcset');
      main.src = thumbs[current].dataset.src;
      thumbs.forEach((t, j) => t.classList.toggle('on', j === current));
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => show(i)));
    $$('[data-dk-g]', root).forEach((b) => b.addEventListener('click', () => show(current + Number(b.dataset.dkG))));

    // options → variant
    const selected = () => groups.map((g) => ($('.opt-vals .on', g) || {}).dataset?.value);
    const findVariant = (sel) => variants.find((v) => sel.every((val, i) => v.options[i] === val));
    function update() {
      const sel = selected();
      const v = findVariant(sel);
      groups.forEach((g, gi) => {
        const label = $('[data-dk-selected]', g);
        if (label) label.textContent = sel[gi] || '';
        $$('.opt-vals button', g).forEach((b) => {
          const trial = sel.slice(); trial[gi] = b.dataset.value;
          const tv = findVariant(trial);
          b.classList.toggle('na', !tv || !tv.available);
        });
      });
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addText.textContent = 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      prices.forEach((p) => { p.textContent = money(v.price); });
      if (stock) { stock.textContent = v.available ? 'In stock' : 'Sold out'; stock.classList.toggle('out', !v.available); }
      if (addBtn) { addBtn.disabled = !v.available; addText.textContent = v.available ? 'Add to cart' : 'Sold out'; addBtn.removeAttribute('aria-disabled'); }
      const sticky = $('[data-dk-sticky-add]', root);
      if (sticky) { sticky.disabled = !v.available; sticky.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      if (v.featured_media && thumbs.length) {
        const i = thumbs.findIndex((t) => t.dataset.mediaId === String(v.featured_media.id));
        if (i >= 0) show(i);
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    }
    groups.forEach((g) => $$('.opt-vals button', g).forEach((b) => b.addEventListener('click', () => {
      $$('.opt-vals button', g).forEach((x) => x.classList.toggle('on', x === b));
      update();
    })));
    if (groups.length) update();

    // quantity
    const qty = $('[data-dk-qty-input]', root);
    $$('[data-dk-qty]', root).forEach((b) => b.addEventListener('click', () => {
      if (!qty) return;
      qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.dkQty));
    }));

    // sticky add-to-cart bar (phones)
    const bar = $('[data-dk-sticky]', root);
    const stickyAdd = $('[data-dk-sticky-add]', root);
    if (bar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => bar.classList.toggle('on', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(addBtn);
      if (stickyAdd) stickyAdd.addEventListener('click', () => addBtn.click());
    }
  }

  /* ---------- YouTube: swap thumbnail for the player on click ---------- */
  function initVideos() {
    $$('[data-dk-yt]').forEach((v) => v.addEventListener('click', (e) => {
      e.preventDefault();
      v.innerHTML = `<iframe src="https://www.youtube-nocookie.com/embed/${encodeURIComponent(v.dataset.dkYt)}?autoplay=1&rel=0" title="DK Offroad on YouTube" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>`;
    }, { once: true }));
  }

  /* ---------- merch waitlist: fold ticked items into the customer tags ---------- */
  function initWaitlist() {
    $$('[data-dk-waitlist]').forEach((form) => form.addEventListener('submit', () => {
      const tags = $('[data-dk-tags]', form);
      const wants = $$('.wants input:checked', form).map((i) => i.value);
      if (tags) tags.value = ['merch-waitlist', 'newsletter'].concat(wants).join(',');
    }));
  }

  function init() {
    $$('[data-dk-header]').forEach(initHeader);
    initCollection();
    $$('[data-dk-product]').forEach(initProduct);
    initVideos();
    initWaitlist();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Theme editor: re-run when a section is re-rendered.
  document.addEventListener('shopify:section:load', init);
})();
